exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qO1DS8mWtoVp3DZeCLg6x {\n  padding: 0;\n  min-width: 0;\n}\n.qO1DS8mWtoVp3DZeCLg6x fieldset {\n  min-width: 0;\n}\n._1axnMshsEG_6pwPnjrXL_5 {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n}\n._1axnMshsEG_6pwPnjrXL_5 > section {\n  flex: 0 1 225px;\n  min-width: 0;\n  padding-bottom: 0 !important;\n}\n", ""]);

// exports
exports.locals = {
	"fieldset": "qO1DS8mWtoVp3DZeCLg6x",
	"container": "_1axnMshsEG_6pwPnjrXL_5"
};